import React from "react";
import ServiceCard3D from "./ServiceCard3D";

export default function ServiceCard({ index, icon: Icon, title, description }) {
    return (
        <div className="group relative p-8 rounded-2xl bg-gray-50/50 hover:bg-white hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-gray-200 overflow-hidden">
            {/* 3D Background */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <ServiceCard3D index={index} />
            </div>

            <div className="relative z-10">
                <div className="w-14 h-14 bg-gradient-to-br from-gray-700 to-gray-800 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{title}</h3>
                <p className="text-gray-600 leading-relaxed">{description}</p>
            </div>
        </div>
    );
}
